<template>
  <NuxtLayout name="layout-default" class="layout">
    <main v-if="job" class="job-default">
      <header class="job-header _ui-grid">
        <h1 class="title text-3xl">{{ job.title }}</h1>
        <Glow />
      </header>
      <Modules :modules="job.content" />
    </main>
  </NuxtLayout>
</template>

<script setup lang="ts">
import Modules from '~/components/modules/Modules.vue';
import Glow from '@/components/site-header/Glow.vue';

const route = useRoute();
const slug = String(route.params.slug);

const i18n = useI18n();

const { data, error } = await useAsyncGql({
  operation: 'GetJobBySlug',
  variables: { slug, locale: i18n.localeProperties.value.siteLocale },
});

const job = data.value?.jobPosting;

if (!job || error.value) {
  showError({
    statusCode: 404,
  });
}
</script>

<style scoped lang="scss">
.layout {
  display: block;
  z-index: 100;
  .job-default {
    display: block;
    @media (--vl) {
      padding-block: 12.5rem 5rem;
    }
    .job-header {
      position: relative;
      width: 100%;
      .title {
        grid-column: 2 / -3;
      }
    }
  }
}
</style>
<style lang="scss">
.layout {
  position: relative;
}
</style>
